import ItemDetails from "./itemDetails";
import withItemDetails from "../withItemDetails";

export default withItemDetails(ItemDetails);
